<template>
	<el-drawer class="monitor-detail-transfer-drawer" :modal-append-to-body="false" title="转接详情" :append-to-body="true" :visible.sync="show" :before-close="closeBox" size="800px">
		<el-container v-if="show">
			<el-header height="40px">
				<div class="tools">
					<label>转接客服：</label>
					<el-input placeholder="请输入要查找的关键词" v-model="listQuery.keyword" clearable  size="mini"></el-input>
					<el-button @click="onSearch" size="mini" type="primary" class="btn">查询</el-button>
				</div>
			</el-header>
			<el-main>
				<table-pagination pagination layout="prev,pager,next" :data="data"
					:column="column" :total="total" :page.sync="listQuery.pageNum" v-loading="loading"
					:limit.sync="listQuery.pageSize" @pagination="getList" />
			</el-main>
			
		</el-container>
	</el-drawer>
</template>

<script>
	export default {
		model:{
			prop:'show',
			event:'close'
		},
		props:{
			show:{
				default:false,
				type:Boolean
			},
			source:{
				default:''
			},
			parent_source:{
				default:''
			}
		},
		watch:{
			show(value){
				if(!value) return;
				this.listQuery.keyword = '';
				this.listQuery.pageNum = 1;
				this.getList();
			}
		},
		data(){
			return {
				listQuery:{
					keyword:'',
					skillGroup:'',
					pageSize:10,
					pageNum:1
				},
				loading:false,
				total:0,
				column:[
					{
						label: "客服",
						prop: "nickName"
					},{
						label: "状态",
						prop: "status",
						render: (h, scope) => {
							return (
								<el-link underline={false} type={scope.row.maxChatNum - scope.row.chatNum > 0 ? 'success' : 'danger'}>{scope.row.maxChatNum - scope.row.chatNum > 0 ? '空闲' : '忙碌'}</el-link>
							);
						}
					},{
						label: "接线中/接线数",
						render: (h, scope) => {
							 return <span>{scope.row.chatNum} / {scope.row.maxChatNum}</span>;
						}
					},{
						label: "操作",
						prop: "action",
						width: 80,
						fixed:'right',
						render: (h, scope) => {
							return (
								<div style="cursor: pointer;">
								  <el-button type="text" disabled={scope.row.id == this.parent_source.id}  onClick={() => this.handleTransformItem(scope.row)}>
								    转接
								  </el-button>
								</div>
							)
						}
					}
				],
				data:[],
			}
		},
		methods:{
			closeBox(){
				this.$emit('close',false)
			},
			onSearch(){
				this.listQuery.pageNum = 1;
				this.getList();
			},
			handleTransformItem(row){
				this.$confirm(`<p>是否将该组会话转给客服 <span style="color:#337EFF">${row.nickName}<span>？</p>`, "", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					center: true,
					dangerouslyUseHTMLString: true,
					customClass: "confirm-element-model"
				}).then(() => {
					 this.$api.transformImServiceToSkillGroupItem(`/livechat/forward/request/csr/${this.source.sessionId}/${this.parent_source.id}/${row.id}/${this.source.brandId}/${this.source.skillGroup}`)
					  .then(res => {
						  if(res.errcode != 0) return;
						  this.$notify.success("已发送转接请求，等待坐席响应");
						  this.closeBox();
						  this.$emit('getList')
					  })
				  })
				  .catch(() => {
				    this.$notify.error("取消转接");
				  });
			},
			getList(){
				this.loading = true;
				this.listQuery.skillGroup = this.source.skillGroup;
				this.$api.getImServiceTransformListsItem(this.listQuery.skillGroup,this.listQuery).then(res => {
					this.loading = false;
					if(res.errcode != 0) return;
					this.data = res.list;
					this.total = res.total;
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.monitor-detail-transfer-drawer {
		.tools {
			height: 100%;
			display: flex;
			align-items: center;
			font-size: 12px;
			label {
				width: 70px;
				display: inline-block;
				font-weight: 400;
				flex-shrink: 0;
			}
			.btn {
				width: 60px;
				margin-left: 10px;
				flex-shrink: 0;
			}
		}
	}
</style>